import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { JwtBearerHelperService } from '@core/services/authentication/jwt-bearer-helper.service';

export const jwtTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const afiliacionURLs = ['/registrar-consentimiento'];
  const validarRecuperacionURLs = [
    '/validar-recuperacion-clave',
    '/completar-recuperacion-clave'
  ];
  const registroURLs = [
    '/ciudadano',
    '/definiciones-acuerdo-usuario',
    '/provincias',
    '/municipios',
    '/sectores',
    '/generar-otp',
    '/validar-otp',
    '/registrar-ciudadano',
    '/usuario',
    '/solicitudes-gestion-usuario',
    '/solicitud-afiliacion-plan-complementario',
    '/contacto-ciudadano',
    '/generar-contrato-afiliacion',
    '/parametro-configuracion',
    '/documento-soporte-solicitud-servicio',
    '/archivos'
  ];

  const jwtHelperService = inject(JwtBearerHelperService);
  const authService = inject(AuthenticationService);

  const tokenResolvers: {
    afiliacion: () => string | null;
    validar_recuperacion: () => string | null;
    registro: () => string | null;
    default: () => string | null;
  } = {
    afiliacion: () => localStorage.getItem('biometric_token'),
    validar_recuperacion: () => new URLSearchParams(window.location.search).get('access_token'),
    registro: () => localStorage.getItem('biometric_token'),
    default: () => jwtHelperService.JWTToken,
  };

  const isRegistrarUsuarioRoute = (): boolean =>
    window.location.pathname.includes('registrar-usuario');

  const getTokenByUrl = (url: string): string | null => {
    // Nota: '/registrar-consentimiento' (afiliación/onboarding) usa biometric_token,
    // pero '/registrar-consentimiento-otorgado' es un endpoint distinto que debe usar
    // el JWT del usuario autenticado. Se excluye explícitamente para no matchear por
    // subcadena y evitar enviar el token equivocado (que provoca 401 y cierre de sesión).
    if (afiliacionURLs.some((u) => url.includes(u)) && !authService.isAuthenticated) {        
      return tokenResolvers.afiliacion();
    }
    if (validarRecuperacionURLs.some((u) => url.includes(u))) {
      return tokenResolvers.validar_recuperacion();
    }
    if (registroURLs.some((u) => url.includes(u)) && isRegistrarUsuarioRoute()) {
      return tokenResolvers.registro();
    }
    return tokenResolvers.default();
  };

  const token = getTokenByUrl(req.url);

  if (token) {
    const clonedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
    return next(clonedReq);
  }
  return next(req);
};
